"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_LOCATIONS = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
exports.GET_LOCATIONS = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query getLocations($where: LocationWhereInput) {\n    locations(where: $where) {\n      id\n      lat\n      lng\n      g1\n      listing {\n        id\n      }\n    }\n  }\n"], ["\n  query getLocations($where: LocationWhereInput) {\n    locations(where: $where) {\n      id\n      lat\n      lng\n      g1\n      listing {\n        id\n      }\n    }\n  }\n"])));
var templateObject_1;
